import React from "react";

export default function Footer() {
  return (
    <footer className="footer text-center text-lg-start">
      <div style={{ fontSize: "1rem", marginTop: "5px" }}>
        <span>
          Desarrollado por el DPTO de Ing. de Datos -
          Tecnoedil S.A.
        </span>
      </div>
    </footer>
  );
}
